// this card is used in specimen details page to show:
// 1. author and reviewer of the specimen,
// 2. last updated time on mobile view,
// 3. ecoregion & commons info
import MultilingualText from 'components/Multilingual/MultilingualText';
import DesignByListItem from 'components/common/DesignByListItem';
import IntlMessages from 'helpers/IntlMessages';
import { useEcoregionInfo } from 'hooks/useEcoregionInfo';
import { Fragment } from 'react';
import { Card } from 'react-bootstrap';
import { FormattedTime, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Speciman } from 'services/graphqltypes';


const AddedByReviewedByCard = ({ specimanBySlug }: { specimanBySlug: Speciman }) => {
  const intl = useIntl();
  const currentLang = useSelector((state: any) => state.settings.locale);
  const ecoregion = useEcoregionInfo(specimanBySlug.bioregionGid);

  return (

    <Card className="mb-3" >
      {/* added by */}
      <Card.Body className="pb-0" >
        <Card.Title className="mb-3">
          <div className="color-theme-1 h4">{intl.formatMessage({ id: 'bioregion.species-added-by' })}</div>
        </Card.Title>
        {specimanBySlug.createdByUser && <div className="mt-3">
          <DesignByListItem
            user={specimanBySlug.createdByUser}
            currentLang={currentLang}
          />
        </div>
        }
      </Card.Body >
      {/* reviewed by */}
      {specimanBySlug.reviewer &&
        <Card.Body className="pb-0 pt-3">
          <Card.Title className="mb-3">
            <div className="color-theme-1 h4">{intl.formatMessage({ id: 'bioregion.species-reviewed-by' })}</div>
          </Card.Title>
          <div className="mt-3">
            <DesignByListItem
              user={specimanBySlug.reviewer}
              currentLang={currentLang}
            />
          </div>
        </Card.Body>
      }

      {/* last updated at, only show on mobile view*/}
      {/* separator */}
      <div className='d-md-none'>
        <div className="border-bottom mb-4 mt-2" />
        <Card.Body className="pt-0">
          <Card.Title className="mb-3">
            <div className="color-theme-1 h4"><IntlMessages id="specimen.last-updated" /></div>
          </Card.Title>
          <div className='align-self-center ml-1 text-normal w-100'>
            <FormattedTime value={specimanBySlug?.updatedAt} year="numeric" month="short" day="2-digit" />
          </div>
        </Card.Body>
      </div>

      {/* commons and ecoregion */}
      {
        (ecoregion || specimanBySlug.territory) &&
        <Fragment>
          {/* separator */}
          <div className="border-bottom mb-4 mt-2" />
          <Card.Body className="pt-0">
            <Card.Title className="mb-3">
              <div className="color-theme-1 h4">{intl.formatMessage({ id: 'bioregion.commons' })} & {intl.formatMessage({ id: 'general.ecoregion' })}</div>
            </Card.Title>
            <div className="align-self-center ml-1 text-normal">
              <MultilingualText value={specimanBySlug.territory?.name} />
            </div>
            <div className="align-self-center ml-1 mt-2 text-normal">
              {ecoregion?.ecoregion?.ecoName}
            </div>
          </Card.Body>
        </Fragment>
      }

    </Card >
  );

};

export default AddedByReviewedByCard;
